


































import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class App extends Vue {
  channel = {
    menuColour: 'black',
    primaryColour: 'black',
  }
  iosUrl = '';

  backgroudColour(colour: string) {
    return `background-color: ${colour}`;
  }

  menuBgColour() {
    const colour = this.channel.menuColour?this.channel.menuColour:this.channel.primaryColour;
    return `background-color: ${colour}`;
  }


  textColor(colour: string) {
    return `color: ${colour}`;
  }

  created() {
    //const url = 'https://vodapi.ezystream.com/v4/channels/3255770?include=appUrl' // for testing
    const url = 'https://vodapi.ezystream.com/v4/channels/from-request?include=appUrl'

    // Simple GET request using fetch
    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.channel = data;
        if (data.homepageType == 13009) {
          this.iosUrl = `https://vodapi.ezystream.com/v4/app/dy-url?channelPartnerId=${data.id}`
        } else {
          this.iosUrl = data.appUrl.ios
        }
        document.title = data.name
      });
  }
}
